import { Link } from "react-router-dom";
import { Phone, ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { SITE } from "@/data/content";

export const HelpCTA = () => (
  <section data-testid="help-cta" className="relative bg-teal text-cream overflow-hidden">
    <div className="absolute -right-24 -top-24 h-80 w-80 rounded-full bg-teal-light/30 blur-3xl" />
    <div className="max-w-7xl mx-auto px-6 md:px-12 py-24 md:py-32 relative">
      <Reveal>
        <p className="text-xs uppercase tracking-[0.25em] text-gold mb-6">Take the First Step</p>
        <h2 className="font-heading text-4xl md:text-6xl leading-[1.05] max-w-3xl">
          Ready to begin the journey back to yourself?
        </h2>
        <p className="mt-6 text-cream/80 text-lg max-w-xl">
          Recovery begins with a single decision. If you or someone you love is struggling with addiction, our caring professionals are here to help — confidentially.
        </p>
        <div className="mt-10 flex flex-col sm:flex-row items-start sm:items-center gap-5">
          <a
            href={`tel:${SITE.phoneHref}`}
            data-testid="help-cta-call"
            className="inline-flex items-center gap-3 bg-sunrise text-white px-8 py-4 rounded-full font-medium hover:bg-ember transition-colors duration-300 shadow-lg shadow-orange-900/20"
          >
            <Phone size={18} /> {SITE.phone}
          </a>
          <Link
            to="/contact"
            data-testid="help-cta-contact"
            className="inline-flex items-center gap-2 text-cream border-b border-cream/40 pb-1 hover:border-gold hover:text-gold transition-colors duration-300"
          >
            View all contact details <ArrowRight size={16} />
          </Link>
        </div>
      </Reveal>
    </div>
  </section>
);
